import moment from 'moment-timezone'

export default {
	methods: {
		colonFormat(timeCode) {
			let timeStr = timeCode.toString()
			let timeHour = timeStr.slice(0, -1)
			let lastNumber = timeStr.substring(timeStr.length - 1, timeStr.length)
			let timeMin
			if (lastNumber === '0') {
				timeMin = '00'
			} else if (lastNumber === '1') {
				timeMin = '00'
			} else if (lastNumber === '2') {
				timeMin = '20'
			} else if (lastNumber === '3') {
				timeMin = '40'
			} else if (lastNumber === '5') {
				timeMin = '30'
			}
			return timeHour + ':' + timeMin
		},
		korFormat(timeCode) {
			let timeStr = timeCode.toString()
			let timeHour = timeStr.slice(0, -1)
			let timeMin =
				timeStr.substring(timeStr.length - 1, timeStr.length) === '0'
					? '00'
					: '30'
			return timeHour + '시 ' + timeMin + '분'
		},
		korFormatFinishTime(timeCode) {
			let timeStr = timeCode.toString()
			let timeHour = timeStr.slice(0, -1)
			let timeMin =
				timeStr.substring(timeStr.length - 1, timeStr.length) === '0'
					? '25'
					: '55'
			return timeHour + '시 ' + timeMin + '분'
		},
		slashFormat(timeCode) {
			return moment(timeCode, 'YYYY-MM-DD').format('YYYY/MM/DD')
		},
		yearMonthDateFormat(date) {
			return moment(date, 'YYYY-MM-DD')
				.locale('ko')
				.format('YYYY/MM/DD(ddd)')
		},
		monthDateFormat(date) {
			return moment(date, 'YYYY-MM-DD')
				.locale('ko')
				.format('MM/DD(ddd)')
		},
		wonCommaFormat(won) {
			return won.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
		},
		momentFormat(date, timecode) {
			return timecode
				? moment
						.tz(
							date + ' ' + this.colonFormat(timecode),
							'YYYY-MM-DD hh:mm',
							'Asia/Seoul',
						)
						.locale('ko')
				: moment.tz(date, 'YYYY-MM-DD', 'Asia/Seoul').locale('ko')
		},
		databaseTimecodeFormat(time) {
			/* time = H:mm */
			let hour = time.slice(0, -3)
			let min = time.substr(-2) === '30' ? 5 : 0
			return hour + min
		},
		databaseCallTimecodeFormat(time) {
			/* time = H:mm */
			let hour = time.slice(0, -3)
			let min = time.substr(-2) === '00' ? 1 : time.substr(-2) === '20' ? 2 : 3
			return hour + min
		},
		sliceB(word) {
			return word.slice(-1) === 'B' ? word.slice(0, -1) : word
		},
	},
}
